import { createApp } from 'vue'
import App from './EnergyTransitionResponsibility.vue'

createApp(App).mount('#app-energy-transition-responsibility')
